import {ICON_TYPES} from '../constants';

export const SaunaIcon = (): JSX.Element => {
  return (
    <svg
      width='21'
      height='21'
      viewBox='0 0 21 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g>
        <path
          d='M10.5184 10.5L8.5015 7.61775C7.84612 6.68325 6.77425 6.125 5.63413 6.125H4.37587C2.92862 6.125 1.75087 7.30275 1.75087 8.75V10.5H0V18.375C0 19.8223 1.17775 21 2.625 21H18.375C19.8223 21 21 19.8223 21 18.375V10.5H10.5184ZM7.875 12.25V19.25H6.125V12.25H7.875ZM9.625 12.25H11.375V19.25H9.625V12.25ZM13.125 12.25H14.875V19.25H13.125V12.25ZM3.5 8.75C3.5 8.26787 3.89287 7.875 4.375 7.875H5.63325C6.20375 7.875 6.74012 8.15413 7.06737 8.62138L8.3825 10.5H3.5V8.75ZM1.75 18.375V12.25H4.375V19.25H2.625C2.14287 19.25 1.75 18.8571 1.75 18.375ZM19.25 18.375C19.25 18.8571 18.8571 19.25 18.375 19.25H16.625V12.25H19.25V18.375ZM2.625 2.1875C2.625 0.98 3.60413 0 4.8125 0C6.02087 0 7 0.979125 7 2.1875C7 3.39587 6.02087 4.375 4.8125 4.375C3.60413 4.375 2.625 3.39587 2.625 2.1875ZM14.2555 4.11862C13.5266 3.38975 13.125 2.41937 13.125 1.38775V0H14.875V1.38775C14.875 1.95212 15.0946 2.48237 15.4936 2.88138C16.2234 3.61112 16.625 4.5815 16.625 5.61312V7H14.875V5.61312C14.875 5.04875 14.6554 4.5185 14.2555 4.11862ZM17.7555 3.24362C17.0266 2.51475 16.625 1.54438 16.625 0.51275V0H18.375V0.51275C18.375 1.07712 18.5946 1.60738 18.9936 2.00638C19.7234 2.73612 20.125 3.7065 20.125 4.73812V6.125H18.375V4.73812C18.375 4.17375 18.1554 3.6435 17.7555 3.24362Z'
          fill='#43494F'
        />
      </g>
    </svg>
  );
};

SaunaIcon.iconType = ICON_TYPES.SAUNA;
